import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './App.css'
import './Components/css/Component.css'
import { store } from './Redux/store';
import { injectStore } from './API/CustomAxios';
injectStore(store)

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
